<template>
  <div>
    <span>{{ label }}:</span>&nbsp;
    <span class="font-weight-bold">{{ value }}</span>
  </div>
</template>
<script>
export default {
  name: 'InlineLabel',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: undefined,
      default: ''
    }
  }
}
</script>